import { useQuery } from '@tanstack/react-query';
import { fetchProducts } from '../services/products';
import type { ProductListParams } from '../types/products.types';

export const productKeys = {
    all: ['products'] as const,
    lists: () => [...productKeys.all, 'list'] as const,
    list: (params: ProductListParams) => [...productKeys.lists(), params] as const,
    liveList: (params: ProductListParams) => [...productKeys.all, 'live-list', params] as const,
    detail: (id: string) => [...productKeys.all, 'detail', id] as const,
};

export const useProductsQuery = (params: ProductListParams = {}) =>
    useQuery({
        queryKey: productKeys.list(params),
        queryFn: () => fetchProducts(params),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });

export const useLiveProductsQuery = (params: ProductListParams = {}) =>
    useQuery({
        queryKey: productKeys.liveList(params),
        queryFn: () => fetchProducts(params),
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
    });
